import React, { useEffect, useState } from "react";
import JsonData from "../data/data.json";
import { Contact } from "./contact";
import "./Advisorybody.css";

const advisors = [
  ["Prof. Bela Das", "Department of Bengali", "Assam University, Silchar"],
  ["Prof. Biswatosh Choudhury", "Former Head, Department of Bengali", "Assam University, Silchar"],
  ["Prof. Munmun Gangopadhyay", "Department of Bengali", "Rabindra Bharati University, Kolkata"],
  ["Prof. Priyakanta Nath", "Department of Bengali", "Assam University, Silchar"],
  ["Prof. Debashis Bhattacharjee", "Department of Bengali", "Assam University, Silchar"],
  ["Prof. Sucharita Bandopadhyay", "Department of Bengali", "University of Calcutta, Kolkata"],
  ["Prof. Amitabha Chakraborty", "Dean, Faculty of Arts", "Delhi University, Delhi"],
  ["Prof. Prakash Kumar Maity", "Department of Bengali, Faculty of Arts", "Banaras Hindu University, Varanasi"],
  ["Prof. Nanda Kumar Bera", "Retired Professor, Department of Bengali", "Ranchi University, Ranchi"],
  ["Prof. Santanu Sarkar", "Department of Bengali", "Assam University, Silchar"],
  ["Dr. Bubul Sharma", "Department of Bengali", "Assam University, Silchar"],
  ["Prof. Ramakanta Das", "Department of Bengali", "Assam University, Silchar"],
  ["Prof. Rami Chakraborty", "Department of Bengali", "Assam University, Silchar"],
  ["Prof. Sanjay Bhattacharjee", "Department of Bengali", "Gauhati University, Guwahati"],
  ["Dr. Prasanta Chakraborty", "Department of Bengali", "Cotton University, Guwahati"],
  ["Dr. Prasun Barman", "Department of Bengali", "Cotton University, Guwahati"],
  ["Dr. Padma Kumari Chakma", "Department of Bengali", "Tripura University, Agartala"],
  ["Dr. Debalina Debnath", "Department of Folklore", "University of Kalyani, Nadia, West Bengal"],
  ["Prof. Dipak Kumar Roy", "Former Vice Chancellor", "Raiganj University, Raiganj, West Bengal"],
  ["Dr. Sougata Chattopadhyay", "Department of Bengali", "Ramsaday College, Howrah, West Bengal"],
  ["Dr. Sekh Makbul Islam", "Department of Bengali", "St. Paul's Cathedral Mission College, Kolkata"],
  ["Prof. Durba Deb", "Department of Bengali", "Assam University, Silchar"],
  ["Dr. Malay Deb", "Department of Bengali", "Tripura University, Suryamaninagar"],
  ["Dr. Sampan Chakrabarty", "Department of Bengali, Faculty of Arts", "Banaras Hindu University, Varanasi"],
];

export const Advisorybody = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <main className="advisory-page">
        <section className="advisory-directory" aria-labelledby="directory-title">
          <div className="advisory-shell">
            <div className="advisory-directory__heading">
              <div>
                <span className="advisory-kicker">Our mentors</span>
                <h2 id="directory-title">Meet the advisory panel</h2>
              </div>
              <span className="advisory-count">{advisors.length} members</span>
            </div>

            <ol className="advisory-grid">
              {advisors.map(([name, role, institution]) => (
                <li className="advisor-card" key={name}>
                  <span className="advisor-card__number" aria-hidden="true" />
                  <div className="advisor-card__monogram" aria-hidden="true">
                    {name.replace(/^(Prof\.|Dr\.)\s*/, "").charAt(0)}
                  </div>
                  <div className="advisor-card__details">
                    <h3>{name}</h3>
                    <p className="advisor-card__role">{role}</p>
                    <p className="advisor-card__institution">{institution}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </section>
      </main>
      <Contact data={landingPageData.Contact} />
    </>
  );
};
